<div class="sec-title">
    <h1>Calendrier des jobs</h1>
</div>
<hr>
<div class="">
  <div class="row">
    <div class="col-lg-3 col-sm-12">
      <div class="mt-5">        
        <ul class="list-group" id="external-events">
          <li class="list-group-item col-12  mb-5" >
            <form [formGroup]="searchSubmissionForm" (ngSubmit)="onSubmitSearch(searchSubmissionForm.value)" novalidate>
              <div class="form-group input-group mb-3">
                <label for="search_submission" class="visually-hidden">Recherche</label>
                <input type="text" class="form-control" name="search_submission" id="search_submission" formControlName="search_submission" placeholder="Recherche...">
                <div class="input-group-append ">
                  <button type="submit" class="input-group-text right-action-btn">
                    <i title="Recherche" class="bi bi-search"></i>
                  </button>
                </div>
              </div>
              <div class="float-lg-start mt-3 mb-3">
                {{no_results_message}}
              </div>
            </form>
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Jobs à Céduler
                  </button>
                </h2>
                <div id="collapseOne" class="accordion-collapse collapse show"  aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                      <li class="list-group-item"  [ngClass]="{'event-border-green': submission.is_job_planned, 'event-border-red': !submission.is_job_planned}"   *ngFor="let submission of submissionsNotAssignedList; let i = index;">
                        <div id="draggable-el-{{i}}" class="client-event badge pill text-bg-primary col-12 event-border-white" data-id="{{submission.submission_id}}">
                          <div>
                            <div class="color-marker" >&nbsp;</div><div class="float-lg-start client-event-label float-lg-start col-8 client-title-unbreak">#{{submission.submission_no}}</div>
                            <div class="float-lg-end">
                              <a type="button" class="btn btn-outline-secondary left-action-btn white btn-small" href="/client/{{submission.client_id}}/editer">
                                <i class="bbi bi bi-person-fill" title="Modifier le client"></i>
                              </a>
                              <a type="button" class="btn btn-outline-secondary right-action-btn white btn-small" href="/soumission/{{submission.submission_id}}/editer">
                                <i class="bi bi-pencil-square" title="Voir la soumission"></i>
                              </a>
                            </div>
                            <div class="float-lg-start me-2 col-9">{{submission.client_first_name}} {{submission.client_last_name}}</div>
                            <div class="float-lg-start">{{submission.address}}<span *ngIf="submission.city != '' ">, {{submission.city}}</span></div>
                          </div>
                        </div>
                      </li>
                  </div>
                </div>
              </div>
            </div>
        </li>
        </ul>
      </div>
    </div>
  
    <div class="col-lg-9 col-sm-12">
      <full-calendar #calendar [options]="calendarOptions" ></full-calendar>
      <!-- [events]="calendarEvents"  -->
    </div>
  </div>
</div>